// `sage preset` installed this file automatically.
// Running `sage preset` again could result in automatic deletion of this file.
// Because of this, we do not recommend editing this file.
import 'bootstrap';

// Enable bootstrap popover
(function ($) {
  $('[data-toggle="popover"]').popover();

  $(window).on('scroll', () => {
    $('[data-toggle="popover"]').popover('hide');
  });
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js